<template>
  <div data-component="agent-profile-popup-info">
    <agent-avatar
      :person="agent"
      :avatar="avatar"
      :width="64"
    />

    <div data-text="name">
      {{ agentMultiUserName || agentName }}
    </div>

    <div data-text="email">
      {{ agent.email }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { AgentAvatar, AvatarOptions } from '@onereach/hitl-base-avatars';

import { IAgent, IAgentMultiUser } from '@/types';
import { getAgentName } from '@/common';
import { getAgentMultiUserName } from '../../common';

export default defineComponent({
  name: 'AgentProfilePopupInfo',
  components: { AgentAvatar },
  props: {
    avatar: {
      type: Object as PropType<AvatarOptions>,
      default: undefined,
    },
    agent: {
      type: Object as PropType<IAgent>,
      required: true,
    },
    multiUser: {
      type: Object as PropType<IAgentMultiUser>,
      default: () => ({}),
    },
  },
  computed: {
    agentMultiUserName() {
      return getAgentMultiUserName(this.multiUser);
    },
    agentName() {
      return getAgentName(this.agent, this.$t.bind(this));
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='agent-profile-popup-info'] {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: var(--s-5) var(--s-5) var(--s-4);

  .agent-avatar {
    background: var(--or-c-surface-variant);
    margin-bottom: var(--s-3);
    align-self: center;
  }

  [data-text='name'],
  [data-text='email'] {
    line-height: 1.5;
    @include text-overflow;
  }

  [data-text='name'] {
    font-size: var(--fs-1);
    font-weight: var(--fs-2);
    color: var(--or-c-on-background);
  }

  [data-text='email'] {
    font-size: var(--fs-0);
    color: var(--or-c-outline);
  }
}
</style>
